import{g as t}from"../get-intrinsic/index.js";import{c as r}from"./index.js";var o=t,i=r,n=i(o("String.prototype.indexOf")),e=function(t,r){var e=o(t,!!r);return"function"==typeof e&&n(t,".prototype.")>-1?i(e):e};export{e as c};
//# sourceMappingURL=callBound.js.map
